module.exports = __webpack_public_path__ + "img/img2.71898566.svg";